import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import Select from 'v3/components/Select';
import Text from 'v3/components/Text';
import { fetchBranchOffices } from 'utils/fetches';

export const toBranchOfficeIds = (branchOffices) =>
  (branchOffices || []).map((branchOffice) => branchOffice.id);

export const branchOfficesSchema = Yup.array()
  .of(Yup.object({ id: Yup.number().required() }))
  .nullable()
  .min(1, 'Campo obrigatório')
  .required('Campo obrigatório');

export default function BranchOfficesSelect({
  value,
  onChange,
  error,
  isDisabled = false,
  label = 'Filiais *',
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    fetchBranchOffices('').then((branchOffices) => {
      if (!isMounted) return;
      setOptions(Array.isArray(branchOffices) ? branchOffices : []);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Select.Async
      label={label}
      multiple
      value={value || []}
      onChange={(values) => onChange(values || [])}
      onSearch={(search) => fetchBranchOffices(search)}
      options={options}
      loading={loading}
      isDisabled={isDisabled}
      error={error}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      NoOptionsComponent={() => <Text>Nenhuma filial disponível</Text>}
    />
  );
}
